<template>
	<div>
		<!-- Header -->
		<div class="section-lg py-7 py-lg-8 pt-lg-9">
			<b-container>
				<div class="header-body text-center my-lg py-lg">
					<b-row class="justify-content-center align-items-center">
						<b-col xl="5" lg="6" md="6" class="px-5">
							<h1 class="">Ooops!</h1>
							<p class="text-lead ">
								This document is not found. Please make sure you are looking for the correct document.
							</p>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<BaseButton tag="a" target="_blank" :href="DominionInformation.dominionWebsite">Visit Dominion Studio</BaseButton>
						</b-col>
					</b-row>
				</div>
			</b-container>
		</div>
		<!-- Page content -->
	</div>
</template>

<script>
import BaseButton from '../../components/BaseButton.vue';
import DominionInformation from '../../resources/DominionInformation';
export default {
	name: 'not-found',
	components: { BaseButton },
	data(){
		return {
			DominionInformation
		}
	}
};
</script>
